import { FirebaseService } from './../../../../../services/firebase.service';
import { User, Client } from 'sharedTypes/client';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    OnDestroy,
    ChangeDetectorRef,
    Output,
    EventEmitter,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-account-info',
    templateUrl: './account-info.component.html',
    styleUrls: ['./account-info.component.scss'],
    standalone: false,
})
export class AccountInfoComponent implements OnInit, OnDestroy {
    @Input() clientId: string = '';
    @Input() isClient = false;
    @Input() uid: string = '';
    client: Client = new Client();

    supportId = '';
    sub: Subscription = new Subscription();

    constructor(public firebaseService: FirebaseService, private glo: GlobalService, private cdr: ChangeDetectorRef) {}

    async ngOnInit() {
        if (this.clientId) {
            this.sub = this.firebaseService.getClient(this.clientId).subscribe((client) => {
                if (client) {
                    this.client = client;
                    this.cdr.detectChanges();
                }
            });
            this.supportId = '';
            const supportUsers = await this.firebaseService.getPdrUser(this.clientId);
            if (supportUsers && supportUsers[0]) {
                this.supportId = supportUsers[0].id;
                this.cdr.detectChanges();
            }
        }
    }

    async setUserFree() {
        console.log(this.uid);
        this.glo.startLoading('Bitte warten...');
        let res;
        try {
            let uid = this.uid;
            res = await this.firebaseService.requestSetUserFree(uid, this.clientId);
            this.glo.sendSnack('Benutzer geändert!');
            this.glo.endLoading();
        } catch (e) {
            this.glo.endLoading();
        }
    }

    async resetMfa() {
        const confirm = await this.glo.confirm('MFA zurücksetzen?').toPromise();
        if (!confirm) {
            return;
        }
        this.glo.startLoading('Bitte warten...');
        let res;
        try {
            res = await this.firebaseService.resetUserMfa(this.uid);
            this.glo.sendSnack('MFA Reset durchgeführt!');
            this.glo.endLoading();
        } catch (e) {
            this.glo.endLoading();
        }
    }
    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    async loginAsAccount(event, userId = '') {
        let localhost = false;
        if (event.shiftKey) {
            localhost = true;
        }
        this.glo.startLoading('Bitte warten...');
        let res;
        try {
            let uid = userId;
            if (!uid) {
                uid = this.uid;
            }
            if (!uid) {
                uid = this.clientId;
            }
            res = await this.firebaseService.requestLoginToken(uid, this.clientId);
        } catch (e) {
            this.glo.endLoading();
        }
        this.glo.endLoading();
        if (res && res.token) {
            if (localhost) {
                window.open('http://localhost:4200/closed/login?token=' + res.token);
            } else {
                window.open('https://app.pdr.cloud/closed/login?token=' + res.token);
            }
        }
    }
}
